module.exports = __webpack_public_path__ + "static/visionar-platform-devices_grey-c2a779185881439465f7f11eae9817fc.png";